import React from 'react'

function SignUp() {
  return (
    <div>Sign Up</div>
  )
}

export default SignUp